module.exports = __webpack_public_path__ + "static/better-employee-01-540w-b7edaf4c0ca06b4b6c0cbaa7cbf65179.jpg";